import { CssBaseline } from "@mui/material"
import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import { GlobalStyle } from "./GlobalStyle"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

createRoot(document.getElementById("root") as HTMLElement).render(
    <>
        <App />
        <CssBaseline />
        <GlobalStyle />
    </>,
)
if (process.env.NODE_ENV === "production") {
    serviceWorkerRegistration.register()
} else {
    serviceWorkerRegistration.unregister()
}
